import HTMLElement from '../html-element/HTMLElement.js';
/**
 * HTMLTableSectionElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLTableSectionElement
 */
export default class HTMLTableSectionElement extends HTMLElement {}
